var map = {
	"./github.svg": 126,
	"./goodreads.svg": 127,
	"./googlescholar.svg": 128,
	"./instagram.svg": 129,
	"./leanpub.svg": 130,
	"./linkedin.svg": 131,
	"./medium.svg": 132,
	"./soundcloud.svg": 133,
	"./twitter.svg": 134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svg ^\.\/.*\.svg$
// module id = 135
// module chunks = 7555878655471 88746230898986